<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/155Cenp/tc-custom/9781400201716.jpg?1708485716656" alt="This image is the cover for the book Change Your Thoughts, Change Your World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Change Your Thoughts, Change Your World
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Discover the path to lasting change</b></p><p>Are you stressed out, exhausted, or in a rut?  Do you feel troubled by negative emotions and feelings and not in control of your thoughts?  In <i>Change Your Thoughts, Change Your World</i>, Bobby Schuller shows you how to get out of the vicious cycle of defeat and start living the victorious life God intended. You can recalibrate your mind and develop positive habits for permanent change by meditating on twelve key thoughts, among them:</p>God wants me to succeed.I can break through overthinking by taking action now.My body is a gift, even though it’s imperfect.Every loss and challenge can be a doorway to a better version of me.I can relax and let go.<p>In clear, specific steps, Schuller shows us how to train our minds through spiritual disciplines and prayer.  By learning to focus on whatever is true, noble, right, pure, lovely, admirable, excellent, or praiseworthy (Phil 4:8), we can change not only our own lives but also impact the world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bobby Schuller
      </h2>
      
      <p class="authorDescription body article"><P>Bobby Schuller is Lead Pastor at Shepherd's Grove church in Garden Grove, California, and the host and preaching pastor of&#160;<I>Hour of Power with Bobby Schuller</I>, a television ministry that broadcasts around the world.&#160;&#160;Bobby graduated from Oral Roberts University in 2003, received his Master of Divinity degree from Fuller Theological Seminary in 2008, and is an ordained minister in the Reformed Church in America. He resides in Costa Mesa, CA, with his wife, Hannah, and their two children, Haven and Cohen.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f9989e6a